export const SET_SETTINGS = "⚙️ Set Settings";
export const SET_SETTING = "⚙️ Set Setting";
